exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".other-options-button{width:100%;border:2px solid #cdcdcd !important;margin-top:1em !important;padding:1em !important}.other-options-button .name{font-weight:bold;font-size:16px}@media(max-width: 575px){.other-options-button{margin-bottom:1em}}.other-options-button svg{font-size:2.7rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/SubComponents/ShowOtherOptions.scss
// module id = 7587
// module chunks = 13